


















import { Component, Vue } from 'vue-property-decorator'

import type { BreadcrumbsItem } from '@/components/lib/Breadcrumbs.vue'

import { notifications } from '@/store/modules/notifications'
import { Notification } from '@/api'
import Breadcrumbs from '@/components/lib/Breadcrumbs.vue'

@Component({
  components: {
    Breadcrumbs,
  },
})
class NotificationDetail extends Vue {
  notificationsModule = notifications.context(this.$store)

  notification: Notification = null

  breadcrumbsItems: Array<BreadcrumbsItem> = [
    {
      text: 'Главная',
      disabled: false,
      to: { name: 'main' },
    },
    {
      text: 'Уведомления',
      disabled: false,
      to: { name: 'notifications' },
    },
    {
      text: this.$route.meta.title,
      disabled: true,
    },
  ]

  async created() {
    if (this.$route.params.notificationId) {
      this.notification = await this.notificationsModule.actions.getNotifById(
        parseInt(this.$route.params.notificationId)
      )
    }
  }
}

export default NotificationDetail
